import React, { useState, useCallback } from "react";
import MockTestMathematics from "../../components/SatCourse/MockTestMathematics";
import { useLocation, useNavigate } from "react-router-dom";

const MockTestMathematicsScreen: React.FC = () => {
  const useLocations = useLocation();
  const navigate = useNavigate();
  const title = useLocations.state?.title || "";
  
  const [isLoading] = useState<boolean>(false);
  const [isError] = useState<string>("");
  const [data] = useState([
    {
      question:
        "The data in the table above were produced by a sleep researcher studying the number of dreams people recall when asked to record their dreams for-one week. Group X consisted of 100 people who observed early bedtimes, and Group Y consisted of 100 people who observed later bedtimes. If a person is chosen a transform from those who are called at-least 1dream, what is the probability that the person belonged to Group Y?",
    },
  ]);
  const [answer] = useState([
    {
      answer: "100",
    },
    {
      answer: "130",
    },
    {
      answer: "500",
    },
    {
      answer: "900",
    },
  ]);

  const HandleId = useCallback(() => {
    navigate("/mocktestreading");
  }, [navigate]);

  const HandleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <>
      <MockTestMathematics
        isLoading={isLoading}
        isError={isError}
        title={title}
        HandleId={HandleId}
        data={data}
        answer={answer}
        HandleBack={HandleBack}
      />
    </>
  );
};
export default MockTestMathematicsScreen;
